var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container" }, [
    _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c("img", {
        attrs: {
          src: "/static/img/survey/BeNeat-New-Logo-2021.png",
          width: _vm.$mq.phone ? "350" : "500",
          alt: "..."
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-center" },
      [_vm.$mq.phone ? [_vm._m(0)] : [_vm._m(1)]],
      2
    ),
    _vm._v(" "),
    _c("div", [
      _c(
        "form",
        {
          attrs: { "data-vv-scope": "form-user-focus-group" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.formSubmit()
            }
          }
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.tel,
                  expression: "form.tel"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "form-control input-jumbo",
              class: {
                "form-alert": _vm.errors.has("form-user-focus-group.tel")
              },
              style: _vm.$mq.phone ? "" : "width:40%",
              attrs: { type: "number", id: "tel", name: "tel" },
              domProps: { value: _vm.form.tel },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "tel", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.has("form-user-focus-group.tel")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n                "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "row no-gutters pl-2" }, [
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.gender,
                        expression: "form.gender"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "gender",
                      id: "man",
                      value: "เพศชาย"
                    },
                    domProps: { checked: _vm._q(_vm.form.gender, "เพศชาย") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "gender", "เพศชาย")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(4)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.gender,
                        expression: "form.gender"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "gender",
                      id: "women",
                      value: "เพศหญิง"
                    },
                    domProps: { checked: _vm._q(_vm.form.gender, "เพศหญิง") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "gender", "เพศหญิง")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(5)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.gender,
                        expression: "form.gender"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "gender",
                      id: "other",
                      value: "other"
                    },
                    domProps: { checked: _vm._q(_vm.form.gender, "other") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "gender", "other")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(6)
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.errors.has("form-user-focus-group.gender")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n                "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "row no-gutters pl-2" }, [
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.age,
                        expression: "form.age"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "age",
                      id: "age_20_30",
                      value: "20-30"
                    },
                    domProps: { checked: _vm._q(_vm.form.age, "20-30") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "age", "20-30")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(8)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.age,
                        expression: "form.age"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "age",
                      id: "age_31_40",
                      value: "31-40"
                    },
                    domProps: { checked: _vm._q(_vm.form.age, "31-40") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "age", "31-40")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(9)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.age,
                        expression: "form.age"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "age",
                      id: "age_41_50",
                      value: "41-50"
                    },
                    domProps: { checked: _vm._q(_vm.form.age, "41-50") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "age", "41-50")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(10)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.age,
                        expression: "form.age"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "age",
                      id: "age_51_60",
                      value: "51-60"
                    },
                    domProps: { checked: _vm._q(_vm.form.age, "51-60") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "age", "51-60")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(11)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.age,
                        expression: "form.age"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "age",
                      id: "age_61",
                      value: "61"
                    },
                    domProps: { checked: _vm._q(_vm.form.age, "61") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "age", "61")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(12)
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.errors.has("form-user-focus-group.age")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n                "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _vm._m(13),
            _vm._v(" "),
            _c("div", { staticClass: "row no-gutters pl-2" }, [
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.state_of_life,
                        expression: "form.state_of_life"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "state_of_life",
                      id: "single",
                      value: "single"
                    },
                    domProps: {
                      checked: _vm._q(_vm.form.state_of_life, "single")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "state_of_life", "single")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(14)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.state_of_life,
                        expression: "form.state_of_life"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "state_of_life",
                      id: "married",
                      value: "married"
                    },
                    domProps: {
                      checked: _vm._q(_vm.form.state_of_life, "married")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "state_of_life", "married")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(15)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.state_of_life,
                        expression: "form.state_of_life"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "state_of_life",
                      id: "divorce",
                      value: "divorce"
                    },
                    domProps: {
                      checked: _vm._q(_vm.form.state_of_life, "divorce")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "state_of_life", "divorce")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(16)
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.errors.has("form-user-focus-group.state_of_life")
              ? _c("div", { staticClass: "mt-1 text-remark -status-alert" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.required_field")) +
                      "\n                "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.form.state_of_life === "single"
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("โสด (Single)")]),
                _vm._v(" "),
                _c("div", { staticClass: "row no-gutters pl-2" }, [
                  _c("div", { staticClass: "exp col-12" }, [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.single_detail,
                            expression: "form.single_detail"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "single_detail",
                          id: "live_alone",
                          value: "live_alone"
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.single_detail, "live_alone")
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.form,
                              "single_detail",
                              "live_alone"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(17)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "exp col-12" }, [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.single_detail,
                            expression: "form.single_detail"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "single_detail",
                          id: "with_family",
                          value: "with_family"
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.single_detail, "with_family")
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.form,
                              "single_detail",
                              "with_family"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(18)
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.form.state_of_life === "married"
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("แต่งงาน (Married)")]),
                _vm._v(" "),
                _c("div", { staticClass: "row no-gutters pl-2" }, [
                  _c("div", { staticClass: "exp col-12" }, [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.married_detail,
                            expression: "form.married_detail"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "married_detail",
                          id: "one_child",
                          value: "one_child"
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.married_detail, "one_child")
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.form,
                              "married_detail",
                              "one_child"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(19)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "exp col-12" }, [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.married_detail,
                            expression: "form.married_detail"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "married_detail",
                          id: "more_than_1_child",
                          value: "more_than_1_child"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.form.married_detail,
                            "more_than_1_child"
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.form,
                              "married_detail",
                              "more_than_1_child"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(20)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "exp col-12" }, [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.married_detail,
                            expression: "form.married_detail"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "married_detail",
                          id: "no_child",
                          value: "no_child"
                        },
                        domProps: {
                          checked: _vm._q(_vm.form.married_detail, "no_child")
                        },
                        on: {
                          change: function($event) {
                            return _vm.$set(
                              _vm.form,
                              "married_detail",
                              "no_child"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(21)
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "salary" } }, [
              _vm._v("รายได้เฉลี่ยต่อเดือน (Average monthly income)")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row no-gutters pl-2" }, [
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.salary,
                        expression: "form.salary"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "salary",
                      id: "s_15_20",
                      value: "15000-20000"
                    },
                    domProps: {
                      checked: _vm._q(_vm.form.salary, "15000-20000")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "salary", "15000-20000")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(22)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.salary,
                        expression: "form.salary"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "salary",
                      id: "s_20_30",
                      value: "20001-30000"
                    },
                    domProps: {
                      checked: _vm._q(_vm.form.salary, "20001-30000")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "salary", "20001-30000")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(23)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.salary,
                        expression: "form.salary"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "salary",
                      id: "s_30_40",
                      value: "30001-40000"
                    },
                    domProps: {
                      checked: _vm._q(_vm.form.salary, "30001-40000")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "salary", "30001-40000")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(24)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.salary,
                        expression: "form.salary"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "salary",
                      id: "s_40_50",
                      value: "40001-50000"
                    },
                    domProps: {
                      checked: _vm._q(_vm.form.salary, "40001-50000")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "salary", "40001-50000")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(25)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "exp col-12" }, [
                _c("div", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.salary,
                        expression: "form.salary"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      name: "salary",
                      id: "s_50",
                      value: "50001"
                    },
                    domProps: { checked: _vm._q(_vm.form.salary, "50001") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "salary", "50001")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(26)
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(27)
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _vm._v("แบบฟอร์มลงทะเบียนเข้าร่วมวิจัย "),
      _c("br"),
      _vm._v(" เพื่อพัฒนาประสบการณ์ "),
      _c("br"),
      _vm._v(' "การเรียกใช้บริการคุณแม่บ้านทําความสะอาด” '),
      _c("br"),
      _vm._v(" ผ่านแอปพลิเคชั่น BeNeat")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("แบบฟอร์มลงทะเบียนเข้าร่วมวิจัย เพื่อพัฒนาประสบการณ์ "),
      _c("br"),
      _vm._v(
        ' "การเรียกใช้บริการคุณแม่บ้านทําความสะอาด” ผ่านแอปพลิเคชั่น BeNeat'
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("หมายเลขโทรศัพท์")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "gender" } }, [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("เพศ (Gender)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "man" } }, [
      _c("span"),
      _vm._v(
        "\n                            เพศชาย (Male)\n                          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "women" } }, [
      _c("span"),
      _vm._v(
        "\n                            เพศหญิง (Female)\n                          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "other" } }, [
      _c("span"),
      _vm._v(
        "\n                            ไม่ระบุ (Other)\n                          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("อายุ (Age)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "age_20_30" } }, [
      _c("span"),
      _vm._v(
        "\n                            20-30 ปี\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "age_31_40" } }, [
      _c("span"),
      _vm._v(
        "\n                            31-40 ปี\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "age_41_50" } }, [
      _c("span"),
      _vm._v(
        "\n                            41-50 ปี\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "age_51_60" } }, [
      _c("span"),
      _vm._v(
        "\n                            51-60 ปี\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "age_61" } }, [
      _c("span"),
      _vm._v(
        "\n                            มากกว่า 61 ปี\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v("สถานภาพ (State of life)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "single" } }, [
      _c("span"),
      _vm._v(
        "\n                            โสด (Single)\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "married" } }, [
      _c("span"),
      _vm._v(
        "\n                            แต่งงาน (Married)\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "divorce" } }, [
      _c("span"),
      _vm._v(
        "\n                            หย่าร้าง/หม้าย (Divorce)\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "live_alone" } }, [
      _c("span"),
      _vm._v(
        "\n                            อยู่คนเดียว (Live alone)\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "with_family" } }, [
      _c("span"),
      _vm._v(
        "\n                            อยู่กับครอบครัว (With family)\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "one_child" } }, [
      _c("span"),
      _vm._v(
        "\n                            มีลูก 1 คน (One child)\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "mb-3", attrs: { for: "more_than_1_child" } },
      [
        _c("span"),
        _vm._v(
          "\n                            มีลูกมากกว่า 1 คน (More than 1 child)\n                            "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "no_child" } }, [
      _c("span"),
      _vm._v(
        "\n                            ไม่มีลูก (No child)\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "s_15_20" } }, [
      _c("span"),
      _vm._v(
        "\n                            15,000 - 20,000 บาท\n                          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "s_20_30" } }, [
      _c("span"),
      _vm._v(
        "\n                            20,001 - 30,000 บาท\n                          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "s_30_40" } }, [
      _c("span"),
      _vm._v(
        "\n                            30,001 - 40,000 บาท\n                          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "s_40_50" } }, [
      _c("span"),
      _vm._v(
        "\n                            40,001 - 50,000 บาท\n                          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mb-3", attrs: { for: "s_50" } }, [
      _c("span"),
      _vm._v(
        "\n                            มากกว่า 50,001 บาท\n                          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center pb-5" }, [
      _c(
        "button",
        {
          staticClass: "btn btn__submit btn-lg px-5 mt-3",
          attrs: { type: "submit" }
        },
        [_vm._v("\n                    Submit\n                ")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d885272", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d885272","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/survey/UserFocusGroup.vue
// module id = 2419
// module chunks = 0